module.exports = __webpack_public_path__ + "img/智能化设备管理平台1.5fd8bf57.jpg";